import React from 'react';
import { Button, Modal } from 'antd';
import { BellAlertIcon } from '@heroicons/react/24/solid';

interface IProps {
  open: boolean;
  title: string;
  content: string;
  handleOk: () => void;
  handleCancel: () => void;
}

const WarningConfirmModal = ({
  open,
  content,
  handleOk,
  handleCancel,
}: IProps) => {
  return (
    <Modal
      width={400}
      open={open}
      onOk={() => handleOk}
      onCancel={handleCancel}
      okText="บันทึก"
      cancelText="ยกเลิก"
      footer={
        <div className="flex w-full gap-2 justify-center">
          <Button key="back" onClick={handleCancel}>
            ยกเลิก
          </Button>
          <Button
            key="submit"
            type="primary"
            form="unit"
            onClick={handleOk}
            className="bg-orange-700 !hover:bg-orange-700"
          >
            ยืนยัน
          </Button>
        </div>
      }
    >
      <div className="flex flex-row w-full gap-5 items-center text-lg">
        <div>
          <BellAlertIcon className="w-10 h-10 text-orange-700" />
        </div>
        <div>{content}</div>
      </div>
    </Modal>
  );
};

export default WarningConfirmModal;
